var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "no-results-container",
      class: [_vm.withBordersClass, _vm.verticalAlignCenterClass],
    },
    [
      _vm.hasIcon
        ? _c("span", { class: [_vm.noResultsIcon, "icon"] })
        : _vm._e(),
      _c("div", { staticClass: "no-results-text" }, [
        _c("p", { staticClass: "first-paragraph" }, [
          _vm._v(_vm._s(_vm.noResultsFirstText)),
        ]),
        _c("p", {
          staticClass: "second-paragraph",
          domProps: { innerHTML: _vm._s(_vm.noResultsSecondText) },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }